<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapterhead"><a id="page_viii"><i>List of Illustrations</i></a></h1><a id="page_viii">
</a><p class="left"><a id="page_viii"></a><span href="#/illustration002#link1" title="Link target outside of Sample">1. Eildon Hill North under snow.</span></p>
<p class="left"><span href="#/illustration002#link2" title="Link target outside of Sample">2. The Mutiny Stones.</span></p>
<p class="left"><span href="#/illustration002#link3" title="Link target outside of Sample">3. Scott’s View.</span></p>
<p class="left"><span href="#/illustration002#link4" title="Link target outside of Sample">4. Anglian fields at Midlem.</span></p>
<p class="left"><span href="#/illustration002#link5" title="Link target outside of Sample">5. Jedburgh Abbey.</span></p>
<p class="left"><span href="#/illustration002#link6" title="Link target outside of Sample">6. Melrose Abbey.</span></p>
<p class="left"><span href="#/illustration002#link7" title="Link target outside of Sample">7. The decorated capital ‘M’ from the Kelso Abbey charter.</span></p>
<p class="left"><span href="#/illustration002#link8" title="Link target outside of Sample">8. Lauder Common Riding.</span></p>
<p class="left"><span href="#/illustration002#link9" title="Link target outside of Sample">9. A swing plough.</span></p>
<p class="left"><span href="#/illustration002#link10" title="Link target outside of Sample">10. A ploughman and his bondager.</span></p>
<p class="left"><span href="#/illustration002#link11" title="Link target outside of Sample">11. Workers in the darning flat at Gardiners’ Mill, Selkirk.</span></p>
<p class="left"><span href="#/illustration002#link12" title="Link target outside of Sample">12. Workers at Philiphaugh, near Selkirk, in 1890.</span></p>
<p class="left"><span href="#/illustration002#link13" title="Link target outside of Sample">13. Gardeners and foresters at Philiphaugh in the 1890s.</span></p>
<p class="left"><span href="#/illustration002#link14" title="Link target outside of Sample">14. Kelso Abbey</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustration001.vue?31cc8dc1